import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';

const ModalModificarCredencialRdp = ({ isOpen, toggle, selectedCredencial, onSave }) => {
    const [formData, setFormData] = useState({
        id: '',
        username: '',
        password: '',
        hostname: '',
        port: '',
        app_name: '',
        working_dir: '',
    });

    useEffect(() => {
        if (selectedCredencial) {
            setFormData({
                id: selectedCredencial.id || '',
                username: selectedCredencial.username || '',
                password: '', // No mostrar password existente
                hostname: selectedCredencial.hostname || '',
                port: selectedCredencial.port || '',
                app_name: selectedCredencial.app_name || '',
                working_dir: selectedCredencial.working_dir || '',
            });
        }
    }, [selectedCredencial]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSave = () => {
        // Filter out empty fields - only send non-empty values
        const updateData = {};

        if (formData.username && formData.username.trim() !== '') {
            if (formData.username.length > 25) {
                alert('El username no puede exceder los 25 caracteres');
                return;
            }
            updateData.username = formData.username.trim();
        }
        if (formData.password && formData.password !== '') {
            updateData.password = formData.password;
        }
        if (formData.hostname && formData.hostname.trim() !== '') {
            if (formData.hostname.length > 50) {
                alert('El hostname no puede exceder los 50 caracteres');
                return;
            }
            updateData.hostname = formData.hostname.trim();
        }
        if (formData.port && formData.port !== '') {
            const portNum = parseInt(formData.port);
            if (isNaN(portNum) || portNum < 1 || portNum > 65535) {
                alert('El puerto debe ser un número entre 1 y 65535');
                return;
            }
            updateData.port = portNum;
        }
        if (formData.app_name !== undefined) {
            updateData.app_name = formData.app_name ? formData.app_name.trim() : null;
        }
        if (formData.working_dir !== undefined) {
            updateData.working_dir = formData.working_dir ? formData.working_dir.trim() : null;
        }

        // Validate at least one field is being updated
        if (Object.keys(updateData).length === 0) {
            alert('Por favor, ingrese al menos un campo para actualizar');
            return;
        }

        onSave(updateData);
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Modificar Credencial RDP</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="id">ID</Label>
                        <Input
                            type="text"
                            name="id"
                            id="id"
                            value={formData.id}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="username">Username</Label>
                        <Input
                            type="text"
                            name="username"
                            id="username"
                            value={formData.username}
                            onChange={handleChange}
                            maxLength={25}
                        />
                        <small className="text-muted">Máximo 25 caracteres</small>
                    </FormGroup>
                    <FormGroup>
                        <Label for="password">Contraseña</Label>
                        <Input
                            type="password"
                            name="password"
                            id="password"
                            value={formData.password}
                            onChange={handleChange}
                            placeholder="Dejar vacío para mantener contraseña actual"
                        />
                        <small className="text-muted">Dejar vacío para mantener la contraseña actual</small>
                    </FormGroup>
                    <FormGroup>
                        <Label for="hostname">Hostname / IP</Label>
                        <Input
                            type="text"
                            name="hostname"
                            id="hostname"
                            value={formData.hostname}
                            onChange={handleChange}
                            maxLength={50}
                        />
                        <small className="text-muted">Máximo 50 caracteres</small>
                    </FormGroup>
                    <FormGroup>
                        <Label for="port">Puerto</Label>
                        <Input
                            type="number"
                            name="port"
                            id="port"
                            value={formData.port}
                            onChange={handleChange}
                            min={1}
                            max={65535}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="app_name">Nombre de Aplicación</Label>
                        <Input
                            type="text"
                            name="app_name"
                            id="app_name"
                            value={formData.app_name || ''}
                            onChange={handleChange}
                            maxLength={255}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="working_dir">Directorio de Trabajo</Label>
                        <Input
                            type="text"
                            name="working_dir"
                            id="working_dir"
                            value={formData.working_dir || ''}
                            onChange={handleChange}
                            maxLength={255}
                        />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSave}>Guardar</Button>
                <Button color="secondary" onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalModificarCredencialRdp;
